import React from 'react';
import DownloadCSVButton from "../report/export/DownloadCSVButton";
import ReportDataSummary from "../report/redesigned/ReportDataSummary";
import {getBuyerInventoryReportUrl} from "./requests/buyer-inventory-requests";
import { Grid } from "@mui/material";


const BuyerInventoryReportDataSummary = ({
                                                                                                         query,
                                                                                                         count,
                                                                                                         title,
                                                                                                         setExpandedItems,
                                                                                                         setExpandedAll,
                                                                                                         isShowCollapseButton = false,
                                                                                                         handleExpandAll,
                                                                                                         hasExpandedItems
                                                                                                       }) => {
  return (
    <ReportDataSummary
      count={count}
      title={title}
      setExpandedItems={setExpandedItems}
      setExpandedAll={setExpandedAll}
      isShowCollapseButton={isShowCollapseButton}
      handleExpandAll={handleExpandAll}
      hasExpandedItems={hasExpandedItems}
    >
      <Grid container justifyContent={'end'} gap={2}>
        <Grid item>
          <DownloadCSVButton
            title={'Download Report'}
            reportUrl={getBuyerInventoryReportUrl(query)}
          />
        </Grid>
      </Grid>
    </ReportDataSummary>
  );
};

export default BuyerInventoryReportDataSummary;
